import { jsx as o, Fragment as s, jsxs as a } from "react/jsx-runtime";
import { forwardRef as f } from "react";
import { c as C } from "../index-BNmRGtA6.js";
import { c as g } from "../clsx-OuTLNxxd.js";
import { B as h } from "../Button-B2Q9lfS-.js";
import '../SocialButton.css';const p = "_facebookButton_g5ict_32", m = "_googleButton_g5ict_33", i = {
  facebookButton: p,
  googleButton: m
};
function B(t) {
  const e = t.replace(/([A-Z])/g, " $1");
  return e.charAt(0).toUpperCase() + e.slice(1);
}
const v = C(i.button, {
  variants: {
    variant: {
      facebook: i.facebookButton,
      google: i.googleButton
    }
  }
}), _ = f(
  ({ children: t, className: e, disabled: c, isLoading: n, variant: l, ...d }, u) => {
    const r = l ? /* @__PURE__ */ o(w, { isLoading: n, variant: l }) : t;
    return /* @__PURE__ */ o(
      h,
      {
        className: g(v({ variant: l }), e),
        "data-cxy-name": "social-button",
        "data-testid": "button-component",
        disabled: c,
        isLoading: n,
        loadingText: n ? /* @__PURE__ */ o(s, { children: r }) : "",
        ref: u,
        ...d,
        children: r
      }
    );
  }
), w = ({ isLoading: t, variant: e }) => {
  const c = {
    facebook: /* @__PURE__ */ o(b, {}),
    google: /* @__PURE__ */ o(V, {})
  }, n = () => c[e], l = B(e);
  return /* @__PURE__ */ a(s, { children: [
    /* @__PURE__ */ o(n, {}),
    /* @__PURE__ */ a("span", { children: [
      t ? "Loading" : `Sign in with ${l}`,
      " "
    ] })
  ] });
};
function b(t) {
  return /* @__PURE__ */ o("svg", { ...t, fill: "none", height: "20", viewBox: "0 0 22 20", width: "22", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ o(
    "path",
    {
      d: "M21.7838 10.1215C21.7838 4.59863 17.0949 0.121481 11.3109 0.121481C5.5268 0.121481 0.837891 4.59863 0.837891 10.1215C0.837891 15.1128 4.66771 19.2498 9.67446 20V13.0121H7.01531V10.1215H9.67446V7.91836C9.67446 5.41211 11.238 4.02773 13.6303 4.02773C14.7761 4.02773 15.9746 4.22304 15.9746 4.22304V6.68398H14.654C13.353 6.68398 12.9473 7.45482 12.9473 8.24564V10.1215H15.8519L15.3875 13.0121H12.9473V20C17.954 19.2498 21.7838 15.1128 21.7838 10.1215Z",
      fill: "white"
    }
  ) });
}
function V(t) {
  return /* @__PURE__ */ a("svg", { ...t, fill: "none", height: "20", viewBox: "0 0 22 20", width: "22", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ o(
      "path",
      {
        clipRule: "evenodd",
        d: "M20.9793 10.2273C20.9793 9.51825 20.9127 8.83643 20.7889 8.18188H10.9253V12.0501H16.5617C16.3189 13.3001 15.581 14.3592 14.4718 15.0682V17.5773H17.8565C19.8368 15.8364 20.9793 13.2728 20.9793 10.2273Z",
        fill: "#4285F4",
        fillRule: "evenodd"
      }
    ),
    /* @__PURE__ */ o(
      "path",
      {
        clipRule: "evenodd",
        d: "M10.9254 19.9999C13.7531 19.9999 16.1238 19.1044 17.8566 17.5772L14.472 15.0681C13.5342 15.6681 12.3345 16.0226 10.9254 16.0226C8.1977 16.0226 5.88889 14.2635 5.06533 11.8999H1.56641V14.4908C3.28969 17.759 6.83146 19.9999 10.9254 19.9999Z",
        fill: "#34A853",
        fillRule: "evenodd"
      }
    ),
    /* @__PURE__ */ o(
      "path",
      {
        clipRule: "evenodd",
        d: "M5.06551 11.8999C4.85605 11.2999 4.73703 10.659 4.73703 9.99994C4.73703 9.34085 4.85605 8.69994 5.06551 8.09994V5.50903H1.56658C0.857274 6.85903 0.452637 8.38631 0.452637 9.99994C0.452637 11.6136 0.857274 13.1409 1.56658 14.4909L5.06551 11.8999Z",
        fill: "#FBBC05",
        fillRule: "evenodd"
      }
    ),
    /* @__PURE__ */ o(
      "path",
      {
        clipRule: "evenodd",
        d: "M10.9254 3.97727C12.4631 3.97727 13.8436 4.48182 14.929 5.47273L17.9328 2.60455C16.1191 0.990909 13.7484 0 10.9254 0C6.83146 0 3.28969 2.24091 1.56641 5.50909L5.06533 8.1C5.88889 5.73636 8.1977 3.97727 10.9254 3.97727Z",
        fill: "#EA4335",
        fillRule: "evenodd"
      }
    )
  ] });
}
export {
  _ as SocialButton,
  v as socialButtonVariants
};
